import TwCitySelector from 'tw-city-selector/dist/tw-city-selector.js';
require('webpack-jquery-ui');
require('jquery-ui/ui/i18n/datepicker-zh-TW.js');
require('../../scss/jq_ui_style/jquery-ui.theme.css')

if ($(".twCitySelector").get().length != 0) {
    new TwCitySelector({
        el: '.twCitySelector',
        elCounty: '#user_cities',
        elDistrict: '#user_district',
        bootstrapStyle: true,
    });
};

let thisYear = new Date().getYear();
$("#datepicker").datepicker({
    changeMonth: true,
    changeYear: true,
    yearRange: `${thisYear + 1800}:${thisYear + 1900}`,
    regional: "zh-TW"
});

// event：
// ================================================================================================
// 會員中心
$('.member_center_msg_title').on('click', () => {
    $('.title_sort_down').toggleClass('check_rotate');
    $('.member_center_msg_content').stop(true, false).slideToggle();
});

// 訊息通知
$('.msg_page_list').on('click', function (event) {
    $(this).children('.msg_title').toggleClass('msg_title_active');
    $(this).children('.msg_content').slideToggle();
});

// 訂單紀錄
$('.orderList_perOrder').on('click', function (event) {
    $(this).children('.orderList_title').toggleClass('orderList_title_active');
    $(this).children('.orderList_content').slideToggle();
});

// 喜愛清單
$('.favorite_list_card_pic').on('mouseenter', function (event) {
    $(this).find('.hover_icon').css({ 'transform': 'translate(0%,-150%)' });
    $('.favorite_list_card_pic').on('mouseleave', function (event) {
        $(this).find('.hover_icon').css({ 'transform': 'translate(0%,0%)' });
    });
});

$('.hover_icon.hover_icon_removeFavorite').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-bookmark-heart').addClass('bi-bookmark-heart-fill');
    $('.hover_icon_removeFavorite').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-bookmark-heart-fill').addClass('bi-bookmark-heart');
    });
});

$('.hover_icon.hover_icon_addCart').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-cart-plus').addClass('bi-cart-plus-fill');
    $('.hover_icon_addCart').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-cart-plus-fill').addClass('bi-cart-plus');
    });
});

